// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hx11","rootMobile":"styles_rootMobile__3_hXC"};